/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import Styles from './Home24ConhecerFinanciamento.css';
import RedButton from '@/components/atoms/RedButton';

function Home24ConhecerFinanciamento() {
  return (
    <section id="santander-conhecer-financiamento">
      <ContainerHome24>
        <div className="santander-conhecer-financiamento-contain">
          <p className="conhecer-text-1">Mais de</p>
          <p className="conhecer-number">800.000</p>
          <p className="conhecer-text-2">
            veículos financiados todos os anos na Santander Financiamentos
          </p>
          <RedButton href="banco-do-auto.html" id="home-conhecer-financiamento" wide>
            Conhecer financiamento
          </RedButton>
        </div>
      </ContainerHome24>
      <img
        src="assets/home24/ic_vehicle_car.svg"
        alt="Metade de um carro em um formato desenhado para mostrar a sessão de veículos financiados na Santander financiamentos"
        className="img-vehicle"
      />
      <div className="elipses" />
      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24ConhecerFinanciamento;
